/**
 * Fine graph-paper grid texture used as a subtle background layer across
 * every dark section — same effect as the TiviOne1.com hero background,
 * redrawn in our own cyan accent. Renders as an absolutely-positioned,
 * pointer-events-none layer, so the parent just needs `position: relative`.
 */
export default function GridTexture({ className = "", fade = true }) {
  return (
    <div
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(rgba(0, 212, 255, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(0, 212, 255, 0.07) 1px, transparent 1px)",
        backgroundSize: "44px 44px",
        maskImage: fade
          ? "radial-gradient(ellipse 100% 100% at 50% 0%, black 40%, transparent 90%)"
          : undefined,
        WebkitMaskImage: fade
          ? "radial-gradient(ellipse 100% 100% at 50% 0%, black 40%, transparent 90%)"
          : undefined,
      }}
    />
  );
}
